import {extraSubduedTextColour, subduedTextColour, tableBorderColour, triggerColour} from "../../style/styleConsts";
import styled, {css} from "styled-components";

export const Cell = styled.div`
    text-align: ${props => props.right ? "right" : "inherit"};
    color: ${props => props.subdued ? subduedTextColour : props.extraSubdued ? extraSubduedTextColour : "inherit"};
`;

const cellStyle = css`
    border-bottom: 1px solid ${tableBorderColour};
`;

export const Td = styled.td`
    ${cellStyle};
    padding: 0;
    vertical-align: top;
    > * {
        padding: 5px 10px;
    }
`;

export const Th = styled.th`
    ${cellStyle};
    text-align: left;
    padding: 5px 10px;
    vertical-align: bottom;
    white-space: nowrap;
`;

export const Tr = styled.tr`
    ${props => props.clickable ? `
        cursor: pointer;
        :hover {
            background-color: ${triggerColour};
            color: white;
        }
    ` : ""}
`;

export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;
`;
